import { connect } from 'react-redux';

import { BucketState } from 'src/types/state';

import MonacoFile from '../components/monaco-file';

const mapStateToProps = (state: BucketState) => ({
  initialThemeSetting: state.global.theme ? state.global.theme : 'default',
});

export default connect(mapStateToProps)(MonacoFile);
